<div class="search-account">
  <div class="flex-body justify-content-between">
    <div class="flex-body">
      <div class="p-inputgroup m-r-12" *ngIf="tableMeta.showAccountSearch">
        <p-autoComplete *ngIf="!(tableMeta.isCustomerUser)" class="m-r-12" type="search" [suggestions]="accounts"
          (completeMethod)="fillAccounts()" [field]="customField" [size]="30" (onSelect)="onSelectAccount($event)"
          [(ngModel)]="accountSearch" [minLength]="3" placeholder="Search for accounts (minimum 3 characters)"
          (onClear)="resetProductCategoryTable()" appendTo="body">
        </p-autoComplete>
        <p-dropdown filter="true" *ngIf="tableMeta.isCustomerUser" class="m-r-12 width-inherit" [options]="accounts"
          filterPlaceholder="Search for accounts (minimum 3 characters)" optionLabel="custom" placeholder="Select"
          (onChange)="accountSelected()" showClear="true" [(ngModel)]="dropDownAccountSelected"
          emptyFilterMessage="Accounts not found." appendTo="body">
        </p-dropdown>
      </div>
      <div class="p-inputgroup m-r-12" *ngIf="tableMeta.displayGlobalSearch" [appClearInput]="gridTable">
        <span class="p-inputgroup-addon"><i class="ei ei-magnifier"></i></span>
        <input [disabled]="disableGrid" class="p-inputtext" type="text" pInputText size="50" [(ngModel)]="searchText"
          placeholder="{{placeHolderText}}" (input)="gridTable.filterGlobal($event.target.value, 'contains')" />
      </div>
      <div>
        <div class="p-button" *ngIf="tableMeta.displayDownloadButton">
          <button pTooltip="{{exportToolTip}}" [disabled]="disableImportExport" pButton icon="ei-download2"
            (click)="downloadWindow()"></button>
        </div>
        <div style="padding-left: 10px;" class="p-button" *ngIf="tableMeta.displayUploadButton">
          <button pTooltip="{{importToolTip}}" [disabled]="disableImportExport" pButton icon="ei-upload2"
            (click)="uploadWindow()"></button>
        </div>
      </div>
    </div>
    <div>
      <button class="p-button" *ngIf="tableMeta.displayCreateButton" pButton (click)="onCreateButtonClick()"
        type="button" icon="ei ei-plus" iconPos="left" label="{{createButtonText}}"></button>
    </div>
  </div>
</div>
<div class="invalid-msg" *ngIf="!isAccountExist">
  Accounts not found
</div>
<div>
  <p-table #gridTable [columns]="columnsMeta" [value]="gridData" [lazy]="!tableMeta.useClientSideFiltering"
    [contextMenu]="gridContext" (onLazyLoad)="lazyLoadData($event)" [(selection)]="selectedTableRows"
    [paginator]="!tableMeta.hidePagination && totalRecords >= 10" [rows]="paginationState.rows"
    [(first)]="paginationState.first" [rowsPerPageOptions]="sizeOptions" [totalRecords]="totalRecords"
    [paginatorDropdownAppendTo]="'body'"
    [showCurrentPageReport]="true" currentPageReportTemplate="{first} - {last} of {totalRecords}"
    (onPage)="paginate($event)" sortField="{{defaultSortColumn}}"
    [ngClass]="{'hide-summary': selectedTableRows?.length === 0}" [sortOrder]="sortOrder">

    <ng-template pTemplate="header" let-columns>
      <tr>
        <th style="width: 2.5em" *ngIf="tableMeta.displayCheckBox">
          <p-tableHeaderCheckbox (click)="onCheckBoxChange()"></p-tableHeaderCheckbox>
        </th>
        <ng-template ngFor let-col [ngForOf]="columns">
          <th *ngIf="col.sortable" [pSortableColumn]="col.field">
            {{col.header}}
            <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
              ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order">
            </p-sortIcon>
          </th>
          <th *ngIf="!col.sortable">
            {{col.header}}
          </th>
        </ng-template>
        <th style="width: 80px" *ngIf="tableMeta.displayKebabMenu"></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-columns="columns">
      <tr [pContextMenuRow]="rowData">

        <td *ngIf="tableMeta.displayCheckBox">
          <p-tableCheckbox [value]="rowData" (click)="onCheckBoxChange()"></p-tableCheckbox>
        </td>

        <ng-template ngFor let-col [ngForOf]="columns">

          <td *ngIf="col.selectable" (click)="onSelectingRow(rowData)" class="wrap-codes">
            <div class="flex-body align-center">
              <a class="anchor">{{resolveFieldData(rowData,col.field)}}</a>
            </div>
          </td>

          <td *ngIf="col.displayIcon" class="wrap-codes">
            <span>
              <i *ngIf="(rowData[col.field] === 'Yes' || rowData[col.field] === 'Enabled' || rowData[col.field] === true)"
                class="ei ei-checkmark-circle green ei-16 m-r-12"></i>
              <i *ngIf="!(rowData[col.field] === 'Yes' || rowData[col.field] === 'Enabled' || rowData[col.field] === true)"
                class="ei ei-cross-circle red ei-16 m-r-12"></i>
            </span>
            <span>{{resolveFieldData(rowData,col.field)}}</span>
          </td>

          <td *ngIf="col.displayYesOrNo" class="wrap-codes">
            <span>
              <i *ngIf="(rowData[col.field] === true)" class="ei ei-checkmark-circle green ei-16 m-r-12"></i>
              <span *ngIf="(rowData[col.field] === true)">Yes</span>
              <i *ngIf="!(rowData[col.field] === true)" class="ei ei-cross-circle red ei-16 m-r-12"></i>
              <span *ngIf="!(rowData[col.field] === true)">No</span>
            </span>

          </td>

          <td *ngIf="col.idDefaultValue" class="wrap-codes">

            <input class="w-full" *ngIf="rowData['fieldType'] === 'Text'" [disabled]="col.disableDefaultValueColumn"
              placeholder="Enter Text" type="text" maxlength="50" (blur)="changeDefaultValue(rowData)"
              [(ngModel)]="rowData[col.field]" appAlphanumericInput pInputText />

            <span *ngIf="rowData['fieldType'] === 'Integer'">
              <input class="w-full"
                [ngClass]="{'invalid-input': (!isValidIntegerValue(+rowData[col.field]) || !validateIntegerValueOnPaste(+rowData[col.field]))}"
                *ngIf="rowData['fieldType'] === 'Integer'" [disabled]="col.disableDefaultValueColumn"
                placeholder="Enter Integer" type="text" maxlength="10" pKeyFilter="int"
                (paste)="validateIntegerValueOnPaste(+rowData[col.field])"
                (keyup)="isValidIntegerValue(+rowData[col.field])" (blur)="changeDefaultValue(rowData)"
                [(ngModel)]="rowData[col.field]" appIntegerInput pInputText />
            </span>
            <input class="w-full" *ngIf="rowData['fieldType'] === 'Decimal'" [disabled]="col.disableDefaultValueColumn"
              placeholder="Enter Decimal" type="text" (blur)="changeDefaultValue(rowData)"
              [(ngModel)]="rowData[col.field]" appDecimalInput pInputText />

            <p-dropdown class="w-full" *ngIf="rowData['fieldType'] === 'Boolean'" appendTo="body"
              [disabled]="col.disableDefaultValueColumn" [options]="booleanTypeValues" optionLabel="label"
              placeholder="Select" (onChange)="changeDefaultValue(rowData)" [showClear]="true"
              [(ngModel)]="rowData[col.field]">
            </p-dropdown>

            <p-dropdown class="w-full" *ngIf="rowData['fieldType'] === 'List'" appendTo="body"
              [disabled]="col.disableDefaultValueColumn" [options]="rowData['additionalFieldListValues']"
              optionLabel="label" placeholder="Select" (onChange)="changeDefaultValue(rowData)" [showClear]="true"
              [(ngModel)]="rowData[col.field]">
            </p-dropdown>

            <p-calendar class="w-full" *ngIf="rowData['fieldType'] === 'Date Only'" appendTo="body"
              [disabled]="col.disableDefaultValueColumn" [showIcon]="true" (onBlur)="changeDefaultValue(rowData)"
              [(ngModel)]="rowData[col.field]">
            </p-calendar>

            <p-calendar class="w-full" *ngIf="rowData['fieldType'] === 'Time Only'" appendTo="body"
              [disabled]="col.disableDefaultValueColumn" [timeOnly]="true" hourFormat="24" [showIcon]="true"
              (onBlur)="changeDefaultValue(rowData)" [(ngModel)]="rowData[col.field]">
            </p-calendar>

            <p-calendar class="w-full" *ngIf="rowData['fieldType'] === 'Date Time'" appendTo="body"
              [disabled]="col.disableDefaultValueColumn" [showTime]="true" hourFormat="24" [monthNavigator]="true"
              [yearNavigator]="true" yearRange="2000:2030" [showIcon]="true" (onBlur)="changeDefaultValue(rowData)"
              [(ngModel)]="rowData[col.field]"></p-calendar>
          </td>

          <td *ngIf="!col.selectable && !col.displayIcon && !col.idDefaultValue && !col.displayYesOrNo"
            class="wrap-codes">
            {{resolveFieldData(rowData,col.field)}}
          </td>

        </ng-template>

        <td *ngIf="tableMeta.displayKebabMenu" (mouseenter)="rowData.hovered=true" (mouseleave)="rowData.hovered=false">
          <div class="table-fields-option">
            <a class="div-inline rotate-90 no-text-decoration pull-right" *ngIf="!rowData.hovered">
              <i class="ei ei-ellipsis ei-16"></i>
            </a>
            <div class="more-options text-right" *ngIf="rowData.hovered">
              <a *ngIf="tableMeta.displayEditMenu" class="div-inline no-text-decoration"
                (click)="onSelectingRow(rowData)">
                <i class="ei ei-pencil ei-16"></i>
              </a>
              <a *ngIf="tableMeta.displayDeleteMenu" class="div-inline no-text-decoration m-l-16"
                (click)="deleteTableRow(rowData)">
                <i class="ei ei-trash2 ei-16"></i>
              </a>
            </div>
          </div>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="summary">
      <div class="flex-body align-items-center">
        <span>{{noOfSelectedTableRows}} selected</span>
        <span class="divider m-r-24 m-l-24"></span>
        <a class="anchor" (click)="onMultipleDelete()">
          <i class="ei ei-trash2 ei-16"></i>&nbsp;<span>Delete</span>
        </a>
      </div>
    </ng-template>

    <ng-template pTemplate="paginatorright" let-state>
      <span class="p-input-current-page-container">
        <span>Page&nbsp;</span>
        <input class="p-input-current-page" title="CurrentPage" type="number" value="1" min="1"
          max="{{ state.pageCount }}" [(ngModel)]="filter.pageNumber" (input)="onPageInput($event)" />
        <span class="p-input-total-pages">&nbsp;/&nbsp;{{ state.pageCount }}</span>
      </span>
    </ng-template>

  </p-table>

  <div class="invalid-msg" *ngIf="checkValidation()">
    No results found
  </div>
</div>

<p-contextMenu #gridContext [hidden]="!tableMeta.displayContextMenu" [model]="contextMenuOptions" appendTo="body">
</p-contextMenu>